import { ReactNode } from 'react';
import Box from '@mui/material/Box';
import Carousel, { useCarousel, CarouselDots, CarouselArrows } from './index';

type Props = {
  height: number;
  isHovered: boolean;
  initialSlide?: number;
  afterChange?: (index: number) => void;
  children?: ReactNode[];
};

export default function CardCarousel({ afterChange, children, height, initialSlide = 0, isHovered }: Props) {
  const carousel = useCarousel({
    autoplay: false,
    lazyLoad: "anticipated",
    ...CarouselDots({
      rounded: true,
    }),
    afterChange,
    initialSlide,
  });

  const handleNextClick = (e) => {
    e.preventDefault();
    carousel.onNext()
  }

  const handlePrevClick = (e) => {
    e.preventDefault();
    carousel.onPrev()
  }

  return (
    <Box
      sx={{
        position: 'relative',
        '& .slick-slide': {
          height,
        }}}
    >
      <CarouselArrows
        areArrowsVisible={isHovered}
        filled
        shape="rounded"
        onNext={handleNextClick}
        onPrev={handlePrevClick}
      >
        <Carousel ref={carousel.carouselRef} {...carousel.carouselSettings}>
          {children}
        </Carousel>
      </CarouselArrows>
    </Box>
  );
}
